<template>
    <div class="auth">
      <v-container class="main-container">
        <div id="auth-content">
          <RouterView />
        </div>
      </v-container>
    </div>
  </template>

  <route lang="yaml">
    meta:
      title: PageTitle
  </route>
    
  
  <style src="../assets/general.css" scoped>
  .auth {
    display: grid;
  }
  .p2 {
    padding-top: 2%;
    padding-bottom: 2%;
  }
  #auth-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 3%;
    /* min-height: 100vh; */
  }
  h2 {
    color: #244125;
  }
  footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    background-image: none;
  }
  @media (max-width: 810px) {
    .responsive-image {
      width: 50%;
    }
  }
  </style>
  